export default "__VITE_ASSET__B9p_9c_O__"